import React from 'react';

import styled from '@emotion/styled';

import { ITrackPackageResponse } from '../../../models/trackPage/trackPackage.model';
import ProcessPackage from './ProcessPackage';
import ShippingStatus from './ShippingStatus';

interface IPackageDetails {
  trackingInfo?: ITrackPackageResponse;
}

const PackageDetails: React.FC<IPackageDetails> = ({ trackingInfo }) => {
  const showFullTrackingInfo = false;

  return (
    <Container>
      <ProcessPackage trackingInfo={trackingInfo} />
      {!showFullTrackingInfo && <ShippingStatus trackingInfo={trackingInfo} />}
    </Container>
  );
};

export default PackageDetails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;
